(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoLibreRegenerarService', ReporteEvaluativoLibreRegenerarService);

    ReporteEvaluativoLibreRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoLibreRegenerarService ($resource) {
    	 var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteLI:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
        	'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteliregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();
